import React from "react";
import MDEditor from '@uiw/react-md-editor';

const MarkdownDisplay = (props) => {

  return (
    <div className="full_width open_sans">
      <MDEditor.Markdown source={props.description} renderers={renderers} />
    </div>
  );
}

export const renderers = {
  link: ({href, children}) => {
    if (href.includes('#')) {
      const href_array = href.split('#')
      const anchor = href_array[1]
      if (!href_array[0] && anchor) {
        return <a style={{color: 'black', textDecoration: 'none'}} id={anchor}>{children[0].props.value}</a>
      }
    }
    return <a href={href}>{children[0].props.value}</a>;
  },
}

export default MarkdownDisplay;
